import React, { useEffect, useMemo, useState } from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import '../fichierCss/Navigation.css';
import RessourceApi from '../api/RessourceApi';
import { estAdministrateur } from '../utils/auth';

const NavigationContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const [annonces, setAnnonces] = useState([]);
  const [peutPiloter, setPeutPiloter] = useState(() => estAdministrateur());
  const [estConnecte, setEstConnecte] = useState(() => Boolean(localStorage.getItem('accessToken')));

  const links = [
    { href: '/', label: 'Accueil' },
    { href: '/presentation', label: 'Qui sommes nous ?' },
    { href: '/actualites', label: 'Actualites' },
    { href: '/profession', label: 'La pratique Sage-Femme' },
    // Le menu déroulant sera géré séparément
  ];

  if (estConnecte) {
    links.splice(4, 0, { href: '/devmembre', label: 'Devenir membre' });
    links.splice(5, 0, { href: '/nosmembres', label: 'Nos membres' });
  }

  useEffect(() => {
    const chargerAnnonces = async () => {
      try {
        const data = await RessourceApi.obtenirRessourcesParCategorie('Annonce');
        const resultats = Array.isArray(data) ? data : [];
        setAnnonces(resultats);
      } catch (error) {
        setAnnonces([]);
      }
    };

    chargerAnnonces();
  }, []);

  useEffect(() => {
    const synchroniserDroitPilotage = () => {
      setPeutPiloter(estAdministrateur());
      setEstConnecte(Boolean(localStorage.getItem('accessToken')));
    };

    window.addEventListener('auth-state-changed', synchroniserDroitPilotage);
    window.addEventListener('storage', synchroniserDroitPilotage);

    return () => {
      window.removeEventListener('auth-state-changed', synchroniserDroitPilotage);
      window.removeEventListener('storage', synchroniserDroitPilotage);
    };
  }, []);

  const texteDefilant = useMemo(() => {
    if (!annonces.length) {
      return 'Aucune annonce disponible pour le moment.';
    }

    return annonces
      .map((annonce) => {
        const nom = annonce?.titre || 'Annonce';
        const description = annonce?.description ? `: ${annonce.description}` : '';
        return `${nom}${description}`;
      })
      .join('   •   ');
  }, [annonces]);

  return (
    <div id="navigation-wrapper">
      <div id="annonces-defilantes" aria-label="Informations annonces">
        <span className="annonces-kicker">Annonces</span>
        <div className="annonces-track-wrap">
          <div className="annonces-track">
            <span>{texteDefilant}</span>
            <span aria-hidden="true">{texteDefilant}</span>
          </div>
        </div>
      </div>

      <div id="navigation">
      <Navbar className="apsam-navbar" variant="dark" expand="lg">
        <Container fluid className="apsam-navbar-shell">
          <Navbar.Toggle aria-controls="apsam-nav-collapse" className="apsam-navbar-toggler" />
          <Navbar.Collapse id="apsam-nav-collapse">
            <Nav className="apsam-nav-list">
              {links.map((link) => {
                const estActif = currentPath === link.href;
                return (
                  <Nav.Link
                    key={link.href}
                    onClick={() => navigate(link.href)}
                    className={`apsam-nav-link ${estActif ? 'is-active' : ''}`}
                    style={{ cursor: 'pointer' }}
                  >
                    {link.label}
                  </Nav.Link>
                );
              })}
              {peutPiloter && (
                <NavDropdown title="Pilotage" id="pilotage-dropdown" className="apsam-nav-link" menuVariant="dark">
                  <NavDropdown.Item
                    onClick={() => navigate('/pilotage-structures-sanitaires')}
                    active={currentPath === '/pilotage-structures-sanitaires'}
                  >
                    Pilotage structures sanitaires
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => navigate('/pilotage-contenus')}
                    active={currentPath === '/pilotage-contenus'}
                  >
                    Pilotage des contenus
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => navigate('/gestion-droits-pilotage')}
                    active={currentPath === '/gestion-droits-pilotage'}
                  >
                    Gestion des droits de pilotage
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => navigate('/pilotage-ressources-categories')}
                    active={currentPath === '/pilotage-ressources-categories'}
                  >
                    Banque des Ressources
                  </NavDropdown.Item>
                </NavDropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      </div>
    </div>
  );
};

export default NavigationContainer;